import React from 'react';
import Button from '@material-ui/core/Button';
import Modal from '../modal/modal';

const ExportModal = ({ open, onClose, onExportUserData, onExportAccountData, accountId, dataCy, ...props }) => {
    return (
        <div className='exportModalContainer'>
            <Modal
                open={open}
                onClose={onClose}
                fullWidth={true}
                maxWidth='md'
                modalHeading="Export Options"
                showActionBtn={false}
                primary
                dataCy={dataCy || props['data-cy'] || 'export-modal'}
            >
                <div className="export-options">
                    <div className="export-option">
                        <div className="export-option-content">
                            <div className="export-option-info">
                                <h4>Export User Account Details</h4>
                                <p>Download user information, permissions, and related account details</p>
                            </div>
                        </div>
                        <Button
                            variant="contained"
                            className="secondarybtn text-white"
                            onClick={() => onExportUserData(accountId)}
                        >
                            Export User Data
                        </Button>
                    </div>
                    <br />

                    <div className="export-option">
                        <div className="export-option-content">
                            <div className="export-option-info">
                                <h4>Export Account Data</h4>
                                <p>Download full account information, configurations, and settings</p>
                            </div>
                        </div>
                        <Button
                            variant="contained"
                            className="secondarybtn text-white"
                            onClick={() => onExportAccountData(accountId)}
                        >
                            Export Account Data
                        </Button>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ExportModal; 